import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-valuer-steps',
  templateUrl: './valuer-steps.component.html',
  styleUrls: ['./valuer-steps.component.scss']
})
export class ValuerStepsComponent {

  constructor() { }

}
